import React, { useEffect, useMemo } from 'react'
import { useRouter } from 'next/router'
import { OpenMobileAppModal } from './OpenMobileAppModal'
import { OpenInAppModal } from './OpenInAppModal'
import { useModal } from '@common/GlobalModal'
import { isMobile } from 'react-device-detect'

type DeepLinkInfo = {
  type: 'permit' | 'checklist' | 'task'
  id: number
} | null

const parseDeepLinkFromPath = (path: string): DeepLinkInfo => {
  const permitMatch = path.match(/\/permits\/(\d+)/)
  if (permitMatch) {
    return { type: 'permit', id: parseInt(permitMatch[1]) }
  }

  const checklistMatch = path.match(/\/checklists\/(\d+)/)
  if (checklistMatch) {
    return { type: 'checklist', id: parseInt(checklistMatch[1]) }
  }

  const taskMatch = path.match(/\/tasks\/(\d+)/)
  if (taskMatch) {
    return { type: 'task', id: parseInt(taskMatch[1]) }
  }

  return null
}

export const OpenMobilePrompt: React.FC<{}> = () => {
  const router = useRouter()
  const { showModal } = useModal()

  const deepLinkInfo = useMemo((): DeepLinkInfo => {
    if (!router.query.redirect) {
      return null
    }
    const redirectPath = decodeURIComponent(router.query.redirect as string)
    return parseDeepLinkFromPath(redirectPath)
  }, [router.query.redirect])

  useEffect(() => {
    if (!isMobile) {
      return
    }

    if (deepLinkInfo) {
      showModal(
        <OpenInAppModal type={deepLinkInfo.type} id={deepLinkInfo.id} />,
      )
    } else {
      showModal(<OpenMobileAppModal />)
    }
  }, [isMobile, deepLinkInfo])

  return null
}
